/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accessApplyDirectoryRoleSetup } from "../funcs/accessApplyDirectoryRoleSetup.js";
import { accessCreateRole } from "../funcs/accessCreateRole.js";
import { accessDeleteDirectoryRoleMapping } from "../funcs/accessDeleteDirectoryRoleMapping.js";
import { accessDeleteRole } from "../funcs/accessDeleteRole.js";
import { accessExplainResourceAccess } from "../funcs/accessExplainResourceAccess.js";
import { accessGetDirectoryReviewSettings } from "../funcs/accessGetDirectoryReviewSettings.js";
import { accessGetRole } from "../funcs/accessGetRole.js";
import { accessGetShadowMCPInventoryServer } from "../funcs/accessGetShadowMCPInventoryServer.js";
import { accessListAIDetections } from "../funcs/accessListAIDetections.js";
import { accessListAIDetectionUsers } from "../funcs/accessListAIDetectionUsers.js";
import { accessListAudienceOptions } from "../funcs/accessListAudienceOptions.js";
import { accessListChallengeBuckets } from "../funcs/accessListChallengeBuckets.js";
import { accessListChallenges } from "../funcs/accessListChallenges.js";
import { accessListDirectoryPeople } from "../funcs/accessListDirectoryPeople.js";
import { accessListDirectoryReviewItems } from "../funcs/accessListDirectoryReviewItems.js";
import { accessListDirectoryRoleMappings } from "../funcs/accessListDirectoryRoleMappings.js";
import { accessListEmployeeAIDetections } from "../funcs/accessListEmployeeAIDetections.js";
import { accessListGrants } from "../funcs/accessListGrants.js";
import { accessListIdentityAccess } from "../funcs/accessListIdentityAccess.js";
import { accessListMembers } from "../funcs/accessListMembers.js";
import { accessListResourceAudience } from "../funcs/accessListResourceAudience.js";
import { accessListRoles } from "../funcs/accessListRoles.js";
import { accessListScopes } from "../funcs/accessListScopes.js";
import { accessListShadowMCPInventory } from "../funcs/accessListShadowMCPInventory.js";
import { accessListShadowMCPInventoryServersForUser } from "../funcs/accessListShadowMCPInventoryServersForUser.js";
import { accessListShadowMCPInventoryUsers } from "../funcs/accessListShadowMCPInventoryUsers.js";
import { accessPreviewDirectoryRoleSetup } from "../funcs/accessPreviewDirectoryRoleSetup.js";
import { accessRequestAccess } from "../funcs/accessRequestAccess.js";
import { accessResolveChallenge } from "../funcs/accessResolveChallenge.js";
import { accessResolveDirectoryReviewItem } from "../funcs/accessResolveDirectoryReviewItem.js";
import { accessResolveShadowMCPInventoryRequest } from "../funcs/accessResolveShadowMCPInventoryRequest.js";
import { accessSetAIToolDecision } from "../funcs/accessSetAIToolDecision.js";
import { accessSetDirectoryRoleMappings } from "../funcs/accessSetDirectoryRoleMappings.js";
import { accessSetResourceAudience } from "../funcs/accessSetResourceAudience.js";
import { accessSyncDirectoryGroups } from "../funcs/accessSyncDirectoryGroups.js";
import { accessUpdateDirectoryReviewSettings } from "../funcs/accessUpdateDirectoryReviewSettings.js";
import { accessUpdateMemberRoles } from "../funcs/accessUpdateMemberRoles.js";
import { accessUpdateRole } from "../funcs/accessUpdateRole.js";
import { accessUpdateShadowMCPInventoryServerName } from "../funcs/accessUpdateShadowMCPInventoryServerName.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { AccessMember } from "../models/components/accessmember.js";
import { ApplyDirectoryRoleSetupResult } from "../models/components/applydirectoryrolesetupresult.js";
import { DirectoryReviewSettings } from "../models/components/directoryreviewsettings.js";
import { DirectoryRoleMapping } from "../models/components/directoryrolemapping.js";
import { DirectoryRoleSetupPreviewResult } from "../models/components/directoryrolesetuppreviewresult.js";
import { ExplainResourceAccessResult } from "../models/components/explainresourceaccessresult.js";
import { ListAIDetectionsResult } from "../models/components/listaidetectionsresult.js";
import { ListAIDetectionUsersResult } from "../models/components/listaidetectionusersresult.js";
import { ListAudienceOptionsResult } from "../models/components/listaudienceoptionsresult.js";
import { ListChallengeBucketsResult } from "../models/components/listchallengebucketsresult.js";
import { ListChallengesResult } from "../models/components/listchallengesresult.js";
import { ListDirectoryPeopleResult } from "../models/components/listdirectorypeopleresult.js";
import { ListDirectoryReviewItemsResult } from "../models/components/listdirectoryreviewitemsresult.js";
import { ListDirectoryRoleMappingsResult } from "../models/components/listdirectoryrolemappingsresult.js";
import { ListIdentityAccessResult } from "../models/components/listidentityaccessresult.js";
import { ListMembersResult } from "../models/components/listmembersresult.js";
import { ListRolesResult } from "../models/components/listrolesresult.js";
import { ListScopesResult } from "../models/components/listscopesresult.js";
import { ListShadowMCPInventoryResult } from "../models/components/listshadowmcpinventoryresult.js";
import { ListShadowMCPInventoryUsersResult } from "../models/components/listshadowmcpinventoryusersresult.js";
import { ListUserGrantsResult } from "../models/components/listusergrantsresult.js";
import { RequestAccessResult } from "../models/components/requestaccessresult.js";
import { ResolveChallengesResult } from "../models/components/resolvechallengesresult.js";
import { ResolveDirectoryReviewItemResult } from "../models/components/resolvedirectoryreviewitemresult.js";
import { ResourceAudienceResult } from "../models/components/resourceaudienceresult.js";
import { Role } from "../models/components/role.js";
import { SetAIToolDecisionResult } from "../models/components/setaitooldecisionresult.js";
import { ShadowMCPInventoryServer } from "../models/components/shadowmcpinventoryserver.js";
import { ShadowMCPInventoryURLState } from "../models/components/shadowmcpinventoryurlstate.js";
import { SyncDirectoryGroupsResult } from "../models/components/syncdirectorygroupsresult.js";
import {
  ApplyDirectoryRoleSetupRequest,
  ApplyDirectoryRoleSetupSecurity,
} from "../models/operations/applydirectoryrolesetup.js";
import {
  CreateRoleRequest,
  CreateRoleSecurity,
} from "../models/operations/createrole.js";
import {
  DeleteDirectoryRoleMappingRequest,
  DeleteDirectoryRoleMappingSecurity,
} from "../models/operations/deletedirectoryrolemapping.js";
import {
  DeleteRoleRequest,
  DeleteRoleSecurity,
} from "../models/operations/deleterole.js";
import {
  ExplainResourceAccessRequest,
  ExplainResourceAccessSecurity,
} from "../models/operations/explainresourceaccess.js";
import {
  GetDirectoryReviewSettingsRequest,
  GetDirectoryReviewSettingsSecurity,
} from "../models/operations/getdirectoryreviewsettings.js";
import {
  GetRoleRequest,
  GetRoleSecurity,
} from "../models/operations/getrole.js";
import {
  GetShadowMCPInventoryServerRequest,
  GetShadowMCPInventoryServerSecurity,
} from "../models/operations/getshadowmcpinventoryserver.js";
import {
  ListAIDetectionsRequest,
  ListAIDetectionsSecurity,
} from "../models/operations/listaidetections.js";
import {
  ListAIDetectionUsersRequest,
  ListAIDetectionUsersSecurity,
} from "../models/operations/listaidetectionusers.js";
import {
  ListAudienceOptionsRequest,
  ListAudienceOptionsSecurity,
} from "../models/operations/listaudienceoptions.js";
import {
  ListChallengeBucketsRequest,
  ListChallengeBucketsSecurity,
} from "../models/operations/listchallengebuckets.js";
import {
  ListChallengesRequest,
  ListChallengesSecurity,
} from "../models/operations/listchallenges.js";
import {
  ListDirectoryPeopleRequest,
  ListDirectoryPeopleSecurity,
} from "../models/operations/listdirectorypeople.js";
import {
  ListDirectoryReviewItemsRequest,
  ListDirectoryReviewItemsSecurity,
} from "../models/operations/listdirectoryreviewitems.js";
import {
  ListDirectoryRoleMappingsRequest,
  ListDirectoryRoleMappingsSecurity,
} from "../models/operations/listdirectoryrolemappings.js";
import {
  ListEmployeeAIDetectionsRequest,
  ListEmployeeAIDetectionsSecurity,
} from "../models/operations/listemployeeaidetections.js";
import {
  ListGrantsRequest,
  ListGrantsSecurity,
} from "../models/operations/listgrants.js";
import {
  ListIdentityAccessRequest,
  ListIdentityAccessSecurity,
} from "../models/operations/listidentityaccess.js";
import {
  ListMembersRequest,
  ListMembersSecurity,
} from "../models/operations/listmembers.js";
import {
  ListResourceAudienceRequest,
  ListResourceAudienceSecurity,
} from "../models/operations/listresourceaudience.js";
import {
  ListRolesRequest,
  ListRolesSecurity,
} from "../models/operations/listroles.js";
import {
  ListScopesRequest,
  ListScopesSecurity,
} from "../models/operations/listscopes.js";
import {
  ListShadowMCPInventoryRequest,
  ListShadowMCPInventorySecurity,
} from "../models/operations/listshadowmcpinventory.js";
import {
  ListShadowMCPInventoryServersForUserRequest,
  ListShadowMCPInventoryServersForUserSecurity,
} from "../models/operations/listshadowmcpinventoryserversforuser.js";
import {
  ListShadowMCPInventoryUsersRequest,
  ListShadowMCPInventoryUsersSecurity,
} from "../models/operations/listshadowmcpinventoryusers.js";
import {
  PreviewDirectoryRoleSetupRequest,
  PreviewDirectoryRoleSetupSecurity,
} from "../models/operations/previewdirectoryrolesetup.js";
import {
  RequestAccessRequest,
  RequestAccessSecurity,
} from "../models/operations/requestaccess.js";
import {
  ResolveChallengeRequest,
  ResolveChallengeSecurity,
} from "../models/operations/resolvechallenge.js";
import {
  ResolveDirectoryReviewItemRequest,
  ResolveDirectoryReviewItemSecurity,
} from "../models/operations/resolvedirectoryreviewitem.js";
import {
  ResolveShadowMCPInventoryRequestRequest,
  ResolveShadowMCPInventoryRequestSecurity,
} from "../models/operations/resolveshadowmcpinventoryrequest.js";
import {
  SetAIToolDecisionRequest,
  SetAIToolDecisionSecurity,
} from "../models/operations/setaitooldecision.js";
import {
  SetDirectoryRoleMappingsRequest,
  SetDirectoryRoleMappingsSecurity,
} from "../models/operations/setdirectoryrolemappings.js";
import {
  SetResourceAudienceRequest,
  SetResourceAudienceSecurity,
} from "../models/operations/setresourceaudience.js";
import {
  SyncDirectoryGroupsRequest,
  SyncDirectoryGroupsSecurity,
} from "../models/operations/syncdirectorygroups.js";
import {
  UpdateDirectoryReviewSettingsRequest,
  UpdateDirectoryReviewSettingsSecurity,
} from "../models/operations/updatedirectoryreviewsettings.js";
import {
  UpdateMemberRolesRequest,
  UpdateMemberRolesSecurity,
} from "../models/operations/updatememberroles.js";
import {
  UpdateRoleRequest,
  UpdateRoleSecurity,
} from "../models/operations/updaterole.js";
import {
  UpdateShadowMCPInventoryServerNameRequest,
  UpdateShadowMCPInventoryServerNameSecurity,
} from "../models/operations/updateshadowmcpinventoryservername.js";
import { unwrapAsync } from "../types/fp.js";

export class Access extends ClientSDK {
  /**
   * applyDirectoryRoleSetup access
   *
   * @remarks
   * Apply a reviewed bulk setup in one transaction: create the requested new roles and replace each listed source's role set. New roles get no grants unless grant_set is given, in which case every new role in the batch gets exactly that set. If any item's version no longer matches, nothing is written and the request returns conflict; preview again. WorkOS role sync for new roles is requested after commit and reported as requested, not done. Creating roles sets up no plugin distribution.
   */
  async applyDirectoryRoleSetup(
    request: ApplyDirectoryRoleSetupRequest,
    security?: ApplyDirectoryRoleSetupSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ApplyDirectoryRoleSetupResult> {
    return unwrapAsync(accessApplyDirectoryRoleSetup(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createRole access
   *
   * @remarks
   * Create a new custom role.
   */
  async createRole(
    request: CreateRoleRequest,
    security?: CreateRoleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Role> {
    return unwrapAsync(accessCreateRole(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteDirectoryRoleMapping access
   *
   * @remarks
   * Remove a directory role mapping.
   */
  async deleteDirectoryRoleMapping(
    request: DeleteDirectoryRoleMappingRequest,
    security?: DeleteDirectoryRoleMappingSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(accessDeleteDirectoryRoleMapping(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteRole access
   *
   * @remarks
   * Delete a custom role (system roles cannot be deleted).
   */
  async deleteRole(
    request: DeleteRoleRequest,
    security?: DeleteRoleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(accessDeleteRole(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * explainResourceAccess access
   *
   * @remarks
   * Explain whether one organization member can connect to, view, and manage one resource, and which rules decide it. The decision comes from the same evaluation as runtime enforcement. A gateway is refused: nothing checks access on its own id, so check each server it fronts instead. Like listIdentityAccess it describes one person's access, so it takes a session only: API keys are not checked against grants and would see any member's rules.
   */
  async explainResourceAccess(
    request: ExplainResourceAccessRequest,
    security?: ExplainResourceAccessSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ExplainResourceAccessResult> {
    return unwrapAsync(accessExplainResourceAccess(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getDirectoryReviewSettings access
   *
   * @remarks
   * Get the organization's directory review settings: whether its admins are emailed when directory changes are waiting for a decision.
   */
  async getDirectoryReviewSettings(
    request?: GetDirectoryReviewSettingsRequest | undefined,
    security?: GetDirectoryReviewSettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DirectoryReviewSettings> {
    return unwrapAsync(accessGetDirectoryReviewSettings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getRole access
   *
   * @remarks
   * Get a role by ID.
   */
  async getRole(
    request: GetRoleRequest,
    security?: GetRoleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Role> {
    return unwrapAsync(accessGetRole(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getShadowMCPInventoryServer access
   *
   * @remarks
   * Get one project-scoped Shadow MCP server inventory URL with usage and policy-bypass state. Requires an authenticated session authorized for org:admin on the active organization.
   */
  async getShadowMCPInventoryServer(
    request: GetShadowMCPInventoryServerRequest,
    security?: GetShadowMCPInventoryServerSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ShadowMCPInventoryServer> {
    return unwrapAsync(accessGetShadowMCPInventoryServer(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAIDetectionUsers access
   *
   * @remarks
   * List the enrolled users one detected AI tool was found for, each with their devices, signals, versions and first and last sightings: the evidence listEmployeeAIDetections gives per tool for one person, expanded the other way round. Org-scoped like listAIDetections and, like it, requires an authenticated session authorized for org:admin on the active organization. Linked alias emails are folded to the canonical identity, so one person is one row. A target with no detections in the organization is not_found.
   */
  async listAIDetectionUsers(
    request: ListAIDetectionUsersRequest,
    security?: ListAIDetectionUsersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAIDetectionUsersResult> {
    return unwrapAsync(accessListAIDetectionUsers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAIDetections access
   *
   * @remarks
   * List AI tools detected on enrolled devices by device-agent AI scans, aggregated per detection target across the organization. Org-scoped — detections attach to devices and enrolled users, not projects. Requires an authenticated session authorized for org:admin on the active organization. Each row carries the organization's gateway access decision for that tool. Display names and categories are decorated from the server's detection target catalog at read time; targets the catalog does not know are listed under their raw reported id.
   */
  async listAIDetections(
    request?: ListAIDetectionsRequest | undefined,
    security?: ListAIDetectionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAIDetectionsResult> {
    return unwrapAsync(accessListAIDetections(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAudienceOptions access
   *
   * @remarks
   * List the principals that can be given access: everyone, roles, people, and agents.
   */
  async listAudienceOptions(
    request?: ListAudienceOptionsRequest | undefined,
    security?: ListAudienceOptionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAudienceOptionsResult> {
    return unwrapAsync(accessListAudienceOptions(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listChallengeBuckets access
   *
   * @remarks
   * List authz challenges grouped into time-based burst buckets. Consecutive challenges with the same dimensions within a 10-minute window are collapsed into a single bucket.
   */
  async listChallengeBuckets(
    request?: ListChallengeBucketsRequest | undefined,
    security?: ListChallengeBucketsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListChallengeBucketsResult> {
    return unwrapAsync(accessListChallengeBuckets(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listChallenges access
   *
   * @remarks
   * List authz challenge events from ClickHouse, enriched with resolution state from PostgreSQL.
   */
  async listChallenges(
    request?: ListChallengesRequest | undefined,
    security?: ListChallengesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListChallengesResult> {
    return unwrapAsync(accessListChallenges(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listDirectoryPeople access
   *
   * @remarks
   * List every live directory profile in the active organization with its name, groups and whether it belongs to a member. Requires an authenticated session authorized for org:admin, because it names people who are not members; API keys cannot enumerate it. Attribute values are not returned.
   */
  async listDirectoryPeople(
    request?: ListDirectoryPeopleRequest | undefined,
    security?: ListDirectoryPeopleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDirectoryPeopleResult> {
    return unwrapAsync(accessListDirectoryPeople(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listDirectoryReviewItems access
   *
   * @remarks
   * List the directory changes waiting for an admin decision, oldest first: a directory group first seen after review started, with no mapping; a new value of an attribute key that already has mappings; and a mapped group or attribute value that has gone from the directory. Each item carries the same proposal and version as previewDirectoryRoleSetup, for resolveDirectoryReviewItem. Nothing is written.
   */
  async listDirectoryReviewItems(
    request?: ListDirectoryReviewItemsRequest | undefined,
    security?: ListDirectoryReviewItemsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDirectoryReviewItemsResult> {
    return unwrapAsync(accessListDirectoryReviewItems(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listDirectoryRoleMappings access
   *
   * @remarks
   * List the organization's directory groups and attribute values, and the roles mapped to them.
   */
  async listDirectoryRoleMappings(
    request?: ListDirectoryRoleMappingsRequest | undefined,
    security?: ListDirectoryRoleMappingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListDirectoryRoleMappingsResult> {
    return unwrapAsync(accessListDirectoryRoleMappings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listEmployeeAIDetections access
   *
   * @remarks
   * List AI tools detected for one enrolled employee in the active organization. The employee email is required so project viewers cannot broaden the request into an organization-wide inventory. Linked alias emails are folded to the canonical identity. Requires project:read on the active project; the access decision on each row carries its state but not who recorded it, when, or why.
   */
  async listEmployeeAIDetections(
    request: ListEmployeeAIDetectionsRequest,
    security?: ListEmployeeAIDetectionsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAIDetectionsResult> {
    return unwrapAsync(accessListEmployeeAIDetections(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listGrants access
   *
   * @remarks
   * List the current user's effective grants, including inherited role grants.
   */
  async listGrants(
    request?: ListGrantsRequest | undefined,
    security?: ListGrantsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListUserGrantsResult> {
    return unwrapAsync(accessListGrants(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listIdentityAccess access
   *
   * @remarks
   * List the MCP servers and skills an identity is authorized to reach, through grants on the user or on any role they hold, less any blocking grant that withdraws the same scope. Authorization only: plugin membership decides what a resource is distributed through, not who may use it, so it does not widen this list.
   */
  async listIdentityAccess(
    request: ListIdentityAccessRequest,
    security?: ListIdentityAccessSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListIdentityAccessResult> {
    return unwrapAsync(accessListIdentityAccess(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listMembers access
   *
   * @remarks
   * List all team members with their role assignments.
   */
  async listMembers(
    request?: ListMembersRequest | undefined,
    security?: ListMembersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListMembersResult> {
    return unwrapAsync(accessListMembers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listResourceAudience access
   *
   * @remarks
   * List who can reach one resource: the principals granted or blocked on it, and the organization-wide rules they inherit.
   */
  async listResourceAudience(
    request: ListResourceAudienceRequest,
    security?: ListResourceAudienceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ResourceAudienceResult> {
    return unwrapAsync(accessListResourceAudience(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listRoles access
   *
   * @remarks
   * List all roles for the current organization.
   */
  async listRoles(
    request?: ListRolesRequest | undefined,
    security?: ListRolesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListRolesResult> {
    return unwrapAsync(accessListRoles(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listScopes access
   *
   * @remarks
   * List all available scopes and their resource types.
   */
  async listScopes(
    request?: ListScopesRequest | undefined,
    security?: ListScopesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListScopesResult> {
    return unwrapAsync(accessListScopes(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listShadowMCPInventory access
   *
   * @remarks
   * List project-scoped Shadow MCP server inventory composed from observed URLs, telemetry usage, and policy-bypass state. Requires an authenticated session authorized for org:admin on the active organization.
   */
  async listShadowMCPInventory(
    request: ListShadowMCPInventoryRequest,
    security?: ListShadowMCPInventorySecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListShadowMCPInventoryResult> {
    return unwrapAsync(accessListShadowMCPInventory(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listShadowMCPInventoryServersForUser access
   *
   * @remarks
   * List the Shadow MCP servers one person reached, with each server's access state. The inverse of listShadowMCPInventoryUsers, which expands a single server into its users.
   */
  async listShadowMCPInventoryServersForUser(
    request: ListShadowMCPInventoryServersForUserRequest,
    security?: ListShadowMCPInventoryServersForUserSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListShadowMCPInventoryResult> {
    return unwrapAsync(accessListShadowMCPInventoryServersForUser(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listShadowMCPInventoryUsers access
   *
   * @remarks
   * List users with observed telemetry usage for one project-scoped Shadow MCP server URL.
   */
  async listShadowMCPInventoryUsers(
    request: ListShadowMCPInventoryUsersRequest,
    security?: ListShadowMCPInventoryUsersSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListShadowMCPInventoryUsersResult> {
    return unwrapAsync(accessListShadowMCPInventoryUsers(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * previewDirectoryRoleSetup access
   *
   * @remarks
   * Propose roles for every live directory group and mappable attribute value, for bulk setup. An unmapped source is proposed one role: the live role whose slug matches the source name, or a new role named after the source. A mapped source is listed with its current roles. Nothing is written. Each item carries a version that applyDirectoryRoleSetup checks to detect changes since the preview; the version authorizes nothing.
   */
  async previewDirectoryRoleSetup(
    request?: PreviewDirectoryRoleSetupRequest | undefined,
    security?: PreviewDirectoryRoleSetupSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DirectoryRoleSetupPreviewResult> {
    return unwrapAsync(accessPreviewDirectoryRoleSetup(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * requestAccess access
   *
   * @remarks
   * Request access to a scope by sending an email notification to organization administrators.
   */
  async requestAccess(
    request: RequestAccessRequest,
    security?: RequestAccessSecurity | undefined,
    options?: RequestOptions,
  ): Promise<RequestAccessResult> {
    return unwrapAsync(accessRequestAccess(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * resolveChallenge access
   *
   * @remarks
   * Dismiss one or more denied authz challenges, or atomically add one custom role to the denied user before recording the challenges as resolved.
   */
  async resolveChallenge(
    request: ResolveChallengeRequest,
    security?: ResolveChallengeSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ResolveChallengesResult> {
    return unwrapAsync(accessResolveChallenge(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * resolveDirectoryReviewItem access
   *
   * @remarks
   * Decide one pending directory review item. approve on a new group or attribute value maps it to the given role set, creating new roles as applyDirectoryRoleSetup does; approve on a missing source removes its mappings. dismiss leaves a new source unmapped, or keeps a missing source's mappings. opt_out_key dismisses a new attribute value and stops raising new values of its key. approve checks version as applyDirectoryRoleSetup does and returns conflict if the source changed. An item that is no longer pending returns conflict.
   */
  async resolveDirectoryReviewItem(
    request: ResolveDirectoryReviewItemRequest,
    security?: ResolveDirectoryReviewItemSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ResolveDirectoryReviewItemResult> {
    return unwrapAsync(accessResolveDirectoryReviewItem(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * resolveShadowMCPInventoryRequest access
   *
   * @remarks
   * Review the latest pending Shadow MCP URL request and resolve all pending requests for that URL.
   */
  async resolveShadowMCPInventoryRequest(
    request: ResolveShadowMCPInventoryRequestRequest,
    security?: ResolveShadowMCPInventoryRequestSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ShadowMCPInventoryURLState> {
    return unwrapAsync(accessResolveShadowMCPInventoryRequest(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setAIToolDecision access
   *
   * @remarks
   * Record whether a detected AI tool may reach this organization's MCP gateway. The decision is organization-level and applies to every server: a blocked tool is refused when it authenticates, so its users see an error their client cannot recover from. Enforcement needs a credential Speakeasy can verify, so a tool that carries no verifiable gateway matcher — one linked only by a self-reported client name, or by nothing at all — cannot be decided on: the request is rejected with bad_request, nothing is recorded, and no summary is returned. An id the organization's scan target catalog does not know is rejected with not_found. Requires an authenticated session authorized for org:admin on the active organization.
   */
  async setAIToolDecision(
    request: SetAIToolDecisionRequest,
    security?: SetAIToolDecisionSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SetAIToolDecisionResult> {
    return unwrapAsync(accessSetAIToolDecision(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setDirectoryRoleMappings access
   *
   * @remarks
   * Replace the full set of roles granted by a directory group or attribute value. An empty role list removes all mappings for the source.
   */
  async setDirectoryRoleMappings(
    request: SetDirectoryRoleMappingsRequest,
    security?: SetDirectoryRoleMappingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Array<DirectoryRoleMapping>> {
    return unwrapAsync(accessSetDirectoryRoleMappings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * setResourceAudience access
   *
   * @remarks
   * Replace the rules that name one resource. Organization-wide rules are left untouched.
   */
  async setResourceAudience(
    request: SetResourceAudienceRequest,
    security?: SetResourceAudienceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ResourceAudienceResult> {
    return unwrapAsync(accessSetResourceAudience(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * syncDirectoryGroups access
   *
   * @remarks
   * Fetch the organization's directory groups from WorkOS and save any that are new or changed.
   */
  async syncDirectoryGroups(
    request?: SyncDirectoryGroupsRequest | undefined,
    security?: SyncDirectoryGroupsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<SyncDirectoryGroupsResult> {
    return unwrapAsync(accessSyncDirectoryGroups(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateDirectoryReviewSettings access
   *
   * @remarks
   * Turn the organization's directory review emails on or off. Pending items stay listed in the dashboard either way, and webhooks are unaffected.
   */
  async updateDirectoryReviewSettings(
    request: UpdateDirectoryReviewSettingsRequest,
    security?: UpdateDirectoryReviewSettingsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DirectoryReviewSettings> {
    return unwrapAsync(accessUpdateDirectoryReviewSettings(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateMemberRoles access
   *
   * @remarks
   * Update a team member's role assignments.
   */
  async updateMemberRoles(
    request: UpdateMemberRolesRequest,
    security?: UpdateMemberRolesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AccessMember> {
    return unwrapAsync(accessUpdateMemberRoles(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateRole access
   *
   * @remarks
   * Update an existing custom role.
   */
  async updateRole(
    request: UpdateRoleRequest,
    security?: UpdateRoleSecurity | undefined,
    options?: RequestOptions,
  ): Promise<Role> {
    return unwrapAsync(accessUpdateRole(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateShadowMCPInventoryServerName access
   *
   * @remarks
   * Update or clear the administrator-defined display name for one project-scoped Shadow MCP inventory server URL.
   */
  async updateShadowMCPInventoryServerName(
    request: UpdateShadowMCPInventoryServerNameRequest,
    security?: UpdateShadowMCPInventoryServerNameSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(accessUpdateShadowMCPInventoryServerName(
      this,
      request,
      security,
      options,
    ));
  }
}
